import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';

const KEY = 'compta.periodes_cloturees';

export async function loadPeriodesCloturees(tenantId: string): Promise<string[]> {
  const raw = await SecureTenantStore.getJson<string[]>(tenantId, KEY, []);
  return Array.isArray(raw) ? raw.filter((p) => /^\d{4}-\d{2}$/.test(p)) : [];
}

export async function savePeriodesCloturees(
  tenantId: string,
  periodes: readonly string[],
): Promise<string[]> {
  const unique = [...new Set(periodes)].sort();
  await SecureTenantStore.setJson(tenantId, KEY, unique);
  return unique;
}

export function isPeriodeCloturee(periodes: readonly string[], periode: string): boolean {
  return periodes.includes(periode);
}
